export const LOADREGIONS_START = 'react/regions/LOADREGIONS_START';
export const LOADREGIONS_COMPLETE = 'react/regions/LOADREGIONS_COMPLETE';
export const LOADREGIONS_ERROR = 'react/regions/LOADREGIONS_ERROR';
export const LOADPOSTALCODE_START = 'react/regions/LOADPOSTALCODE_START';
export const LOADPOSTALCODE_COMPLETE = 'react/regions/LOADPOSTALCODE_COMPLETE';
export const LOADPOSTALCODE_ERROR = 'react/regions/LOADPOSTALCODE_ERROR';
export const CHANGEREGIONS = 'react/regions/CHANGEREGIONS';
export const REGIONS_DESTROY = 'react/regions/REGIONS_DESTROY';

const initialState = {
  list: [],
  value: '',
  loading: false
};

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case LOADREGIONS_COMPLETE:
      try {
        return {
          ...state,
          list: action.result.regions || [action.result.region],
          loading: false
        };
      } catch (err) {
        return {
          ...state,
          list: [],
          loading: false
        };
      }
    case LOADREGIONS_START:
      return {
        ...state,
        loading: true
      };
    case LOADREGIONS_ERROR:
      return {
        ...state,
        loading: false
      };
    case REGIONS_DESTROY:
      return initialState;
    case CHANGEREGIONS:
      return {
        ...state,
        value: action.data
      };
    default:
      return state;
  }
}

export function loadRegions(body) {
  return {
    types: [LOADREGIONS_START, LOADREGIONS_COMPLETE, LOADREGIONS_ERROR],
    promise: (client) => client.post('/api/address/addressInput', { data: body })
  };
}

export function loadDataPostalCode(body, index) {
  return {
    types: [LOADPOSTALCODE_START, LOADPOSTALCODE_COMPLETE, LOADPOSTALCODE_ERROR],
    promise: (client) => client.get('/api/address/postalCode/' + index)
  };
}

export function changeRegions(data) {
  return {
    type: CHANGEREGIONS,
    data
  };
}

export function destroyRegions() {
  return { type: REGIONS_DESTROY };
}



// WEBPACK FOOTER //
// ./Scripts/redux/modules/addressForm/regions.js